// extracted by mini-css-extract-plugin
export default {"content":"HeroContent_content__77arZ","title":"HeroContent_title__Qy4QU","description":"HeroContent_description__1F8dv","control":"HeroContent_control__2baFq"};